export const ERROR_MESSAGES = {
    NULL_BRIDGE: "Bridge was null or undefined.",
    NULL_FEED: "Feed was null or undefined.",
    NULL_FEED_TARGETS: "Feed targets was null or undefined.",
    FEED_TARGETS_NOT_ARRAY: "Feed targets was not passed as an array.",
    EMPTY_TARGETS: "Feed targets was empty.",
};
